import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import { fontWeightBold, h3Regular } from "../typography/MuiTypography.style";

export const MuiRadioGroupWrapper = styled.div`
  .mui-label {
    margin-top: 7px;
    color: ${COLORS.cirrus_black10};
    margin-bottom: 8px;
    &.disabled {
      color: ${COLORS.cirrus_black5};
    }
  }
  .asterisk {
    color: ${COLORS.cirrus_red};
  }

  .radio-heading {
    ${h3Regular}
    ${fontWeightBold}
      color: ${COLORS.cirrus_black};
    line-height: 19.36px;
  }

  .MuiFormGroup-root {
    margin-top: 8px;
    ${responsive.MOBILE`
      margin-top: 0;
    `}

    .MuiFormControlLabel-root {
      margin-right: 42px;
    }

    .MuiButtonBase-root {
      .MuiSvgIcon-root {
        color: ${COLORS.primary_light_blue};
        fill: ${COLORS.primary_light_blue};
      }
    }
    .MuiTypography-root {
      ${h3Regular}
      color: ${COLORS.cirrus_black};
      line-height: 22px;
      margin-right: 16px;
    }
  }
`;
